var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { CaseRepaymentService } from "~/services/domain-service/case-repayment.service";
import { namespace, Getter } from "vuex-class";
import { UserService } from "~/services/management-service/user.service";
var CollectionExecutionModule = namespace('collection-execution');
var RecordQuery = /** @class */ (function (_super) {
    __extends(RecordQuery, _super);
    function RecordQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.totalInfo = {};
        _this.searchModel = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            name: "",
            createTime: [],
            caseRepaymentMethod: "",
            caseMoney: { min: '', max: '' }
        };
        _this.dataSet = [];
        _this.userDataSet = [];
        _this.userModel = {
            deptCode: ""
        };
        return _this;
    }
    RecordQuery.prototype.queryTotalAmount = function () {
        var _this = this;
        this.caseRepaymentService
            .caseRepaymentAmount(this.searchModel)
            .subscribe(function (data) { return (_this.totalInfo = data); });
    };
    RecordQuery.prototype.queryRepaymentRecord = function () {
        var _this = this;
        this.caseRepaymentService
            .selectCaseRepayment(this.searchModel, this.pageService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    RecordQuery.prototype.refreshData = function () {
        this.queryRepaymentRecord();
        this.queryTotalAmount();
    };
    RecordQuery.prototype.handleResetForm = function () {
        this.searchModel.caseMoney = { min: '', max: '' };
    };
    RecordQuery.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 导出
     */
    RecordQuery.prototype.exportData = function () {
        var _this = this;
        this.caseRepaymentService
            .exportCaseRepayment(this.searchModel)
            .subscribe(function (data) {
            _this.$common.downloadFile(data.url, data.originalName);
            _this.$message.success('导出成功!');
        });
    };
    __decorate([
        Dependencies(PageService)
    ], RecordQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RecordQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseRepaymentService)
    ], RecordQuery.prototype, "caseRepaymentService", void 0);
    __decorate([
        Dependencies(UserService)
    ], RecordQuery.prototype, "userService", void 0);
    __decorate([
        Getter
    ], RecordQuery.prototype, "departmentData", void 0);
    __decorate([
        Getter
    ], RecordQuery.prototype, "isSupperAdmin", void 0);
    RecordQuery = __decorate([
        Auth(2307),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange
            }
        })
    ], RecordQuery);
    return RecordQuery;
}(Vue));
export default RecordQuery;
